const THEME_STORAGE_KEY = 'strangers_theme_v1';
const THEME_LIGHT = 'light';
const THEME_DARK = 'dark';

const isBrowser = () => (typeof window !== 'undefined' && typeof document !== 'undefined');

const normalizeTheme = (theme) => (theme === THEME_DARK ? THEME_DARK : THEME_LIGHT);

const getStoredTheme = () => {
  if (!isBrowser() || !window.localStorage) {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (raw !== THEME_LIGHT && raw !== THEME_DARK) {
      return null;
    }
    return raw;
  } catch (error) {
    return null;
  }
};

const getSystemTheme = () => {
  if (!isBrowser() || typeof window.matchMedia !== 'function') {
    return THEME_LIGHT;
  }

  return (window.matchMedia('(prefers-color-scheme: dark)').matches ? THEME_DARK : THEME_LIGHT);
};

export const getTheme = () => {
  const stored = getStoredTheme();
  if (stored) {
    return stored;
  }
  return getSystemTheme();
};

export const applyTheme = (theme) => {
  const nextTheme = normalizeTheme(theme);
  if (!isBrowser()) {
    return nextTheme;
  }

  document.documentElement.setAttribute('data-theme', nextTheme);
  return nextTheme;
};

export const setTheme = (theme, persist = true) => {
  const nextTheme = applyTheme(theme);
  if (persist && isBrowser() && window.localStorage) {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, nextTheme);
    } catch (error) {
      return nextTheme;
    }
  }
  return nextTheme;
};

export const toggleTheme = () => {
  const currentTheme = getTheme();
  const nextTheme = (currentTheme === THEME_DARK ? THEME_LIGHT : THEME_DARK);
  return setTheme(nextTheme, true);
};

export const initTheme = () => {
  return applyTheme(getTheme());
};

